export const THEMES = {
  BASIC: 'basic',
  DARK: 'dark',
  LIGHT: 'light'
}